<mat-toolbar class="sidenav-header">
  <div class="menu-container">
    <div class="pg-title">Upload Template</div>
    <button mat-icon-button (click)="close($event)">
      <mat-icon>closed</mat-icon>
    </button>
  </div>
</mat-toolbar>
<mat-divider></mat-divider>

<div class="form-field">
  <div class="upload-container">
    <div class="value-f">Upload File</div>
    <button mat-icon-button (click)="fileInputCL.click()" type="button">
      <img src="assets/icons/upload-icon.png" alt="" />
    </button>
    <input
      type="file"
      name="uploadedFile"
      #Image
      accept=".xls,.xlsx"
      style="display: none"
      #fileInputCL
      (change)="fileChangeEvent($event)"
    />
  </div>
  <div *ngIf="uploadedFile" class="extra-upload-container">
    <span class="underlined-blue">
      {{ uploadedFile.name }}
    </span>
    <button mat-icon-button (click)="deleteFile()" type="button">
      <mat-icon>cancel</mat-icon>
    </button>
  </div>
  <mat-divider></mat-divider>
  <button
    style="margin-top: 24px"
    [disabled]="!uploadedFile"
    mat-raised-button
    color="primary"
    class="full-width"
    (click)="onUpload()"
  >
    Upload
  </button>
</div>
